// extracted by mini-css-extract-plugin
export default {"topbar":"BlogPages_topbar__w-0qF","heading":"BlogPages_heading__o8aGe","mainwrapper":"BlogPages_mainwrapper__O7V8X"};